// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchByType_search_input_container__kT\\+3v {
  width: 100%;
}

.SearchByType_search_container__fkP6Q {
  position: relative;
  width: 100%;
}

.SearchByType_no_options_message__p2Vo8 {
  width: 100%;
  background-color: var(--color-theme-gray);
  padding: 12px 16px;
  border-bottom: 10px solid #ffffff;
}

.SearchByType_input__W9VJI {
  width: 100%;
}

.SearchByType_search_tag__A2TYj {
  display: inline-flex;
  align-items: center;
  background-color: var(--color-theme-lightblue, #e3f2fd);
  color: var(--color-theme-blue, #1976d2);
  border: 1px solid var(--color-theme-blue, #1976d2);
  border-radius: 12px;
  padding: 2px 6px;
  margin-right: 6px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.SearchByType_search_tag__A2TYj span {
  margin-right: 4px;
}

.SearchByType_search_dropdown_autocomplete__Hl691 {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: scroll;
  border-top: 10px solid #ffffff;
}

.SearchByType_dropdown_option_autocomplete__3wlg9 {
  display: grid;
  grid-template-columns: 100px 1fr;
  padding: 12px 16px;
  cursor: pointer !important;
  font-size: 14px;
}

.SearchByType_dropdown_option__8E-Ty:last-child {
  border-bottom: none;
}

.SearchByType_dropdown_option__8E-Ty:hover {
  background-color: var(--color-theme-gray);
}

/* Fixed header */
.SearchByType_dropdown_header__7xilS {
  display: grid;
  grid-template-columns: 100px 1fr;
  padding: 8px;
  background: var(--color-theme-gray);
  position: sticky !important;
  border-top-color: black 10px;
  top: 0;
  z-index: 2;
}
.SearchByType_search_dropdown__hUYWs {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.SearchByType_dropdown_option__8E-Ty {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
}

.SearchByType_dropdown_option__8E-Ty:last-child {
  border-bottom: none;
}

.SearchByType_dropdown_option__8E-Ty:hover {
  background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/SearchByType/SearchByType.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uDAAuD;EACvD,uCAAuC;EACvC,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,MAAM;EACN,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".search_input_container {\n  width: 100%;\n}\n\n.search_container {\n  position: relative;\n  width: 100%;\n}\n\n.no_options_message {\n  width: 100%;\n  background-color: var(--color-theme-gray);\n  padding: 12px 16px;\n  border-bottom: 10px solid #ffffff;\n}\n\n.input {\n  width: 100%;\n}\n\n.search_tag {\n  display: inline-flex;\n  align-items: center;\n  background-color: var(--color-theme-lightblue, #e3f2fd);\n  color: var(--color-theme-blue, #1976d2);\n  border: 1px solid var(--color-theme-blue, #1976d2);\n  border-radius: 12px;\n  padding: 2px 6px;\n  margin-right: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.search_tag span {\n  margin-right: 4px;\n}\n\n.search_dropdown_autocomplete {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: scroll;\n  border-top: 10px solid #ffffff;\n}\n\n.dropdown_option_autocomplete {\n  display: grid;\n  grid-template-columns: 100px 1fr;\n  padding: 12px 16px;\n  cursor: pointer !important;\n  font-size: 14px;\n}\n\n.dropdown_option:last-child {\n  border-bottom: none;\n}\n\n.dropdown_option:hover {\n  background-color: var(--color-theme-gray);\n}\n\n/* Fixed header */\n.dropdown_header {\n  display: grid;\n  grid-template-columns: 100px 1fr;\n  padding: 8px;\n  background: var(--color-theme-gray);\n  position: sticky !important;\n  border-top-color: black 10px;\n  top: 0;\n  z-index: 2;\n}\n.search_dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.dropdown_option {\n  padding: 12px 16px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.dropdown_option:last-child {\n  border-bottom: none;\n}\n\n.dropdown_option:hover {\n  background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search_input_container": `SearchByType_search_input_container__kT+3v`,
	"search_container": `SearchByType_search_container__fkP6Q`,
	"no_options_message": `SearchByType_no_options_message__p2Vo8`,
	"input": `SearchByType_input__W9VJI`,
	"search_tag": `SearchByType_search_tag__A2TYj`,
	"search_dropdown_autocomplete": `SearchByType_search_dropdown_autocomplete__Hl691`,
	"dropdown_option_autocomplete": `SearchByType_dropdown_option_autocomplete__3wlg9`,
	"dropdown_option": `SearchByType_dropdown_option__8E-Ty`,
	"dropdown_header": `SearchByType_dropdown_header__7xilS`,
	"search_dropdown": `SearchByType_search_dropdown__hUYWs`
};
export default ___CSS_LOADER_EXPORT___;
